<template>
  <div class="StockAntsCompliance">
    <!-- <MobileNav :page_title="nav_title" ></MobileNav> -->
    <RetailNavbar :page_title="nav_title"></RetailNavbar>

    <div class="faq-container">
      <h1 class="heading text-center">StockAnts Compliance</h1>

      <el-row>
        <el-col :xs="0" :sm="4" :md="4" :lg="4" :xl="4">&nbsp;</el-col>
        <el-col :xs="24" :sm="16" :md="16" :lg="16" :xl="16">
          <ul>
            <li>
              StockAnts is a marketplace for price estimates. We are a B2B2C
              platform and service provider where we help with price estimate
              (only from lawful source) tracking of SEBI Registered Experts
              (Research Analyst & Registered Investment Advisor) and
              aggregation, enabling retail users to make investment decisions.
            </li>
            <li>
              StockAnts neither offers algorithmic trading services/strategies
              to investors for automated execution of trades nor promotes any
              services of any broker for execution of trades. There are no
              claims of high returns nor rating assigned to the research data on
              StockAnts platform. There is no effort, in any manner whatsoever,
              by StockAnts to lure investors.
            </li>
            <li>
              StockAnts displays research data from lawful source (SEBI
              Registered Experts (Research Analyst & Registered Investment
              Advisor)) on 'as is basis'. StockAnts does not provide its own
              research / analysis / advice on stocks, investment ideas. The
              research data displayed on StockAnts platform is only from
              Registered Investment Advisers and /or Research Analysts
              registered with SEBI.
            </li>

            <li>
              StockAnts will display recommendations and price estimates from
              SEBI registered Research Analyst only. StockAnts has verified the
              details of the research analyst related to SEBI registration
              before onboarding.
            </li>

            <li>
              The Registered Investment Advisor and/or Research Analysts have to
              agree to the terms and conditions of StockAnts at the time of
              onboarding and consented to sharing of their recommendations and
              price estimates by StockAnts on an “as-is basis”.
            </li>
            <li>
              StockAnts does not promote any tips of stocks and derivatives
              published by SEBI Registered Experts on the platform. It is
              mandatory the research analysts to share research report and / or
              rationale behind their recommendations.
            </li>
            <li>
              StockAnts provides Price estimate tracking of price estimates on
              its platform. Such data is shown by StockAnts on an “as is basis”.
            </li>
            <li>
              StockAnts does not give any rating and / or ranking for the
              performance of the recommendations of the Registered Investment
              Advisor and/or Research Analysts.
            </li>
            <li>
              StockAnts does not allow indicating or guaranteeing returns by
              Registered Investment Advisor and/or Research Analysts.
            </li>
            <li>
              StockAnts does not indulge into games or leagues for promotion of
              its services or of research of the Registered Investment Advisor
              and/or Research Analysts.
            </li>
            <li>
              StockAnts does not have community engagement or forums and does
              not allow or promote copy trade.
            </li>
            <li>
              All codes and the applications provided by StockAnts are a
              property of StockAnts and are owned by StockAnts.
            </li>
            <li>
              Any act of copying of the data, which is shared with the users,
              for reproduction, for redistribution or for any other purpose
              including but not limited to text content and graphics to any
              other server or location including caching of any kind,
              decompiling, reverse engineering, or disassembling the content is
              expressly prohibited. In case of such acts been committed, the
              user will the liable to indemnify StockAnts for the loss or
              liability incurred by Stock Analyst.
            </li>
            <li>
              StockAnts does not store on its servers, any data received from
              Stock Brokers, related to personal information or trades done by
              the users or clients.
            </li>

            <li>
              StockAnts is technology support platform and does not promote
              products or services of any SEBI registered intermediary directly
              or indirectly.
            </li>
            <li>
              StockAnts is a technology platform for research analyst to
              showcase their recommendation and price estimates on an as is
              basis. SEBI registered Research Analysts do not and cannot use
              StockAnts for any promotion or advertisement of their
              services/products.
            </li>
            <li>
              SEBI registered Stock Brokers are given API links to source price
              estimates and to enable trades and transactions of the investors.
              Stock Brokers do not and cannot use StocksAnts for any promotion
              or advertisement of their services/products.
            </li>
            <li>
              The compensation received by StockAnts is for providing the
              technology support to the Brokers. There are no commission-based
              payouts or referral fee payments to StockAnts.
            </li>
            <li>
              StockAnts does not use the product or service of Stock Brokers. In
              turn, Stock Brokers are using the services of StockAnts for their
              commercial use.
            </li>
            <li>
              StockAnts in no manner induces the clients to avail the products
              or services of any Registered Investment Advisor and/or Research
              Analysts or Stock Broker. Stock Ants does not deal with investors
              or clients of any Registered Investment Advisor and/or Research
              Analysts or Stock Broker.
            </li>
          </ul>
        </el-col>
      </el-row>

      <h1 class="heading text-center" style="margin-top: 35px;">
        SEBI Risk Disclosure
      </h1>
      <el-row>
        <el-col :xs="0" :sm="4" :md="4" :lg="4" :xl="4">&nbsp;</el-col>
        <el-col :xs="24" :sm="16" :md="16" :lg="16" :xl="16">
          <ul>
            <li>
              9 out of 10 individual traders in equity Futures and Options
              Segment, incurred net losses.
            </li>
            <li>
              On an average, loss makers registered net trading loss close to ₹
              50,000.
            </li>
            <li>
              Over and above the net trading losses incurred, loss makers
              expended an additional 28% of net trading losses as transaction
              costs.
            </li>
            <li>
              Those making net trading profits, incurred between 15% to 50% of
              such profits as transaction cost.
            </li>
            <li>
              SEBI study dated January 25, 2023 on Analysis of Profit and Loss
              of Individual Traders dealing in equity Futures and Options (F&O)
              Segment, wherein Aggregate Level findings are based on annual
              Profit/Loss incurred by individual traders in equity F&O during FY
              2021-22
            </li>

            <li>
              More detail
              <a
                href="https://www.sebi.gov.in/reports-and-statistics/research/jan-2023/study-analysis-of-profit-and-loss-of-individual-traders-dealing-in-equity-fando-segment_67525.html"
                target="__blank"
                >Click here</a
              >
            </li>
          </ul>
        </el-col>
      </el-row>

      <div
        class="agreement-auth-bypass"
        v-if="currentEnvironment && currentEnvironment.byPassLogin"
      >
        <h1 class="heading text-center" style="margin-top: 35px;">
          StockAnts Subscription Agreement
        </h1>
        <el-row>
          <el-col :xs="0" :sm="4" :md="4" :lg="4" :xl="4">&nbsp;</el-col>
          <el-col :xs="24" :sm="16" :md="16" :lg="16" :xl="16">
            <ul>
              <li>
                StockAnts Subscription Agreement
                <a
                  href="https://prod-api.stockants.com/Media/important_doc/StockAnts_subscription_Agreement.pdf"
                  download="StockAnts Subscription Agreement.pdf"
                  style="text-decoration: none;
                          color: #2d2e8d;"
                  target="_blank"
                  >Click here</a
                >
              </li>
            </ul>
          </el-col>
        </el-row>
      </div>

      <h1 class="heading text-center" style="margin-top: 35px;">
        Disclosure between StockAnts, Connected Brokers, SEBI-registered
        Research Analysts
      </h1>

      <el-row>
        <el-col :xs="0" :sm="4" :md="4" :lg="4" :xl="4">&nbsp;</el-col>
        <el-col :xs="24" :sm="16" :md="16" :lg="16" :xl="16">
          <ul>
            <li>
              <b>As per SEBI circular</b>
              <a
                href="https://www.sebi.gov.in/legal/circulars/oct-2024/association-of-persons-regulated-by-the-board-and-their-agents-with-certain-persons_87837.html"
                target="_blank"
              >
                dated 8th Oct 2024</a
              >
            </li>
            <ul>
              <li>
                <b>Platform Compliance and Transparency</b> - StockAnts
                exclusively displays SEBI-Registered Research Analysts
                recommendations on an ‘as-is’ basis, in accordance with SEBI
                guidelines. No unregistered or unauthorized
                research/recommendation/advice is shown on the platform.
              </li>
              <li>
                <b>No Performance Claims or Guarantees</b> - SEBI-Registered
                Research Analysts recommendations on StockAnts do not offer any
                claims or guarantees regarding returns or performance, either
                expressly or impliedly, for any securities or investments.
              </li>
              <li>
                <b>Separation from Unregulated Entities</b> - In line with
                SEBI’s October 2024 circular, StockAnts ensures that it operates
                only with authorized brokers and SEBI-Registered Research
                Analysts and no collaborations with unregulated entities are
                permitted.
              </li>
            </ul>

            <li>
              <b
                >As per SEBI Circular no. SEBI/HO/MIRSD/DOP/P/CIR/2022/117 dated
                September 02, 2022</b
              >
            </li>
            <ul>
              <li>
                <b>No Algorithmic Trading:</b> StockAnts does not offer or
                support algorithmic trading strategies, ensuring full compliance
                with SEBI Circular no. SEBI/HO/MIRSD/DOP/P/CIR/2022/117 dated
                September 02, 2022.
              </li>
              <li>
                <b>No Performance Assurance:</b> StockAnts refrains from
                displaying any past performance, expected returns, or ROI on any
                strategy or product. This aligns with our commitment to
                transparency and user empowerment in accordance with SEBI
                regulations.
              </li>
            </ul>

            <li>
              <b
                >SEBI Circular no. SEBI/HO/MIRSD/ MIRSD-PoD-1/P/CIR/2025/1 dated January 29, 2025</b
              >
            </li>
            <ul>
              <li>
                StockAnts does <b>not allow unregistered individuals</b> to publish advice.
              </li>
              <li>
                All recommendations and strategies are shared only by SEBI-registered RAs and displayed by StockAnts on an ‘as is’ basis
              </li>

              <li>
               No past performance, past returns or claims from RAs is displayed
              </li>
              <li>
               No <b>expected return or forward projections</b>  are made or published.
              </li>
            </ul>
          </ul>
        </el-col>
      </el-row>
    </div>

    <RetailFooter></RetailFooter>
  </div>
</template>

<script>
// import MobileNav from "@/components/MobileNav.vue";
import { screenSize } from "../mixins/ScreenSize.js";
import RetailNavbar from "@/components/RetailSideCompo/RetailNavbar.vue";
import { EventBus } from "../eventBus";
import RetailFooter from "@/components/RetailSideCompo/RetailFooter.vue";

export default {
  name: "StockAntsCompliance",
  components: {
    // MobileNav,
    RetailNavbar,
    RetailFooter,
  },
  mixins: [screenSize],

  data() {
    return {
      nav_title: "StockAnts Compliance",
      pdfLink: "/public/StockAnts Subscription Agreement.pdf",
      currentEnvironment: localStorage.getItem("currentEnvironment")
        ? JSON.parse(localStorage.getItem("currentEnvironment"))
        : {},
    };
  },

  computed() {},
  computed: {
    userProfile() {
      return JSON.parse(localStorage.getItem("profile"));
    },
  },
  beforeDestroy() {
    EventBus.$off();
  },
};
</script>

<style lang="scss" scoped>
.StockAntsCompliance {
  .faq-container {
    padding: 30px 0 50px;
  }

  h1 {
    font-size: 1.6rem;
    font-weight: 600;
    margin: 0;
    color: #322e79;
  }

  p {
    font-size: 12px;
    color: #6d6a6a;
  }

  ul {
    list-style: none;

    li {
      font-size: 12px;
      margin: 10px 0;
      color: #6d6a6a;
    }

    li::before {
      content: "\2022";
      color: #322e79;
      font-weight: bold;
      width: 1em;
      margin-left: -1em;
      font-size: 25px;
      position: relative;
      margin-right: 16px;
      top: 3px;
    }
  }

  @media screen and (max-width: 876px) {
    h1 {
      font-size: 1.4rem;
    }

    .faq-container {
      padding: 70px;
      padding-top: 30px !important;
    }
  }

  @media screen and (max-width: 600px) {
    h1 {
      font-size: 1.2rem;
    }

    .faq-container {
      padding: 70px 35px;
    }
  }

  @media screen and (max-width: 450px) {
    //     h1 {
    //     font-size: 1.2rem;
    // }
    .faq-container {
      padding: 70px 20px;
    }
  }
}
</style>
